export default "__VITE_ASSET__$nj0R3XC__"